import { map } from 'rxjs';

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import {
  ActivatedRoute,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';
import { AuthFacade } from '@ideapa/app-auth';
import { ExtendedRoute } from '@ideapa/app-common';
import { NavigationFacade } from '@ideapa/app-navigation';
import { sort } from '@ideapa/common-utils';
import { Store } from '@ngrx/store';

// import { RouterFacade } from '@heitown/frontend-routing-utils';

@Component({
  standalone: false,
  selector: 'ideapa-tab-layout',
  templateUrl: './tab-layout.component.html',
  styleUrls: ['./tab-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabLayoutComponent {
  isLoading: boolean | undefined;

  currentModulo$ = this.authFacade.modulo$;

  currentEnte$ = this.authFacade.ente$;

  currentAnno$ = this.authFacade.anno$;

  hideNav$ = this.activatedRoute.queryParams.pipe(
    map(
      (params) => false
      // !!params[this.routerFacade.VIEW_MODE_PARAM] ||
      // !!params[this.routerFacade.ADD_MODE_PARAM] ||
      // !!params[this.routerFacade.FIND_MODE_PARAM] ||
      // !!params[this.routerFacade.EDIT_MODE_PARAM]
    )
  );

  tabs$ = this.navigationFacade.tabs$.pipe(
    map((tabs) =>
      tabs
        .filter((t) => t.tabOpened === true)
        .sort((t1, t2) => (t1.tabPosition || 0) - (t2.tabPosition || 0))
    )
  );

  closeTab(path: string, event: Event) {
    if (path === 'home') {
      this.navigationFacade.closeTab(path);
      this.navigationFacade.navigateToFirstAvailableTab();
    } else {
      this.navigationFacade.manualCloseTab(path);
    }
    event.stopImmediatePropagation();
    event.preventDefault();
    return false;
  }

  clearModulo() {
    this.authFacade.clearModulo();
  }

  showSelectModulo() {
    this.authFacade.showSelectModuloPopup(null);
  }

  constructor(
    private router: Router,
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute, // private routerFacade: RouterFacade,
    private navigationFacade: NavigationFacade,
    private store: Store,
    private authFacade: AuthFacade
  ) {
    // Spinner for lazyload modules
    router.events.forEach((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.isLoading = true;
        this.cd.detectChanges();
      } else if (event instanceof RouteConfigLoadEnd) {
        this.isLoading = false;
        this.cd.detectChanges();
      }
      //  else if (event instanceof NavigationEnd) {
      //   this.navigationFacade.showTab((event as NavigationEnd).url);
      // }
    });
  }

  showClose(t: ExtendedRoute, tabs: ExtendedRoute[]) {
    if (t.path !== 'home') return true;
    else {
      const openedTabs = tabs.filter((t) => t.tabOpened);
      if (openedTabs.length > 1) return true;

      return openedTabs[0].path !== 'home';
    }
  }
}
